import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type FavoriteIssuePath = '/v1/workspaces/{workspace_id}/issues/favorite';

type FavoriteIssueParams = Partial<PathParams<FavoriteIssuePath, 'patch'>> &
  RequestBody<FavoriteIssuePath, 'patch'>;
type FavoriteIssueFunction = (params: FavoriteIssueParams) => Promise<void>;

/**
 * 이슈 즐겨찾기 토글
 */
export const favoriteIssue: FavoriteIssueFunction = ({
  workspace_id,
  name,
  favorite,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .patch(`/workspaces/${wa}/issues/favorite`, { name, favorite })
    .then((res) => res.data);
};
